const clean = (value) => String(value || "").trim();

export const isMonitorAccessRevoked = (error) => {
  const code = clean(error?.code).replace(/^functions\//, "");
  return code === "permission-denied" || code === "unauthenticated";
};
